import { Component, Input, OnChanges } from "@angular/core";

import { MobileComponent } from "../mobile/interface/mobile.component";
import { TitleWidgetComponent } from "./title-widget/title-widget.component";
import { CommonModule } from "@angular/common";
import { DescriptionWidgetComponent } from "./description-widget/description-widget.component";

@Component({
  selector: "rfc-heading-widget",
  templateUrl: "./heading-widget.component.html",
  styleUrls: ["./heading-widget.component.scss"],
  standalone: true,
  imports: [
    TitleWidgetComponent,
    CommonModule,
    DescriptionWidgetComponent
  ]
})
export class HeadingWidgetComponent
  extends MobileComponent
  implements OnChanges
{
  @Input() headingName;
  @Input() description;
  constructor() {
    super();
  }

  ngOnChanges() {}
}
